"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConfirmDialogModule = /** @class */ (function () {
    function ConfirmDialogModule() {
    }
    return ConfirmDialogModule;
}());
exports.ConfirmDialogModule = ConfirmDialogModule;
